// Saved HTML keeps the Vue scope IDs of its original build. Match scope owners
// against the mounted counterpart so a new build can style the preserved DOM.
export function snapshotScopeMap(saved, live) {
  const signature = node => `${node.tag}|${node.classes.filter(name => !/^(is-|on$|off$|matched$|winning$|dim$)/.test(name)).sort().join(' ')}`;
  const counterparts = new Map();
  for (const node of live) {
    const key = signature(node);
    if (!counterparts.has(key)) counterparts.set(key, []);
    counterparts.get(key).push(node);
  }
  const candidates = new Map();
  for (const node of saved) {
    if (!node.classes.length) continue;
    const matches = counterparts.get(signature(node));
    if (!matches?.length) continue;
    const common = matches.reduce((set, match) => new Set([...set].filter(scope => match.scopes.includes(scope))), new Set(matches[0].scopes));
    for (const scope of node.scopes) {
      candidates.set(scope, candidates.has(scope)
        ? new Set([...candidates.get(scope)].filter(value => common.has(value)))
        : new Set(common));
    }
  }
  return candidates;
}

export function restoreSnapshotStyles(snapshot, live) {
  if (!snapshot || !live) return;
  const describe = root => [...root.querySelectorAll('*')].map(element => ({
    element, tag: element.tagName, classes: [...element.classList],
    scopes: [...element.attributes].map(attr => attr.name).filter(name => /^data-v-[\w-]+$/.test(name)),
  }));
  const saved = describe(snapshot);
  const mapping = snapshotScopeMap(saved, describe(live));
  for (const node of saved) for (const scope of node.scopes) {
    for (const current of mapping.get(scope) || []) node.element.setAttribute(current, '');
  }
}
